/**
 * Created by Ning Jiang on 11/22/2016.
 */

require("pixi.js");
require("pixi-spine");
require("gsap");

import {EdisonGameModuleConfig} from "./EdisonGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";


export class Edison extends SlotGame {

    constructor() {
        super(EdisonGameModuleConfig.instance);
    }

    getNoWinGameData():any {
        return {
            "reels": [
                [
                    "L1",
                    "M5",
                    "L2",
                    "L3",
                    "L4"
                ],
                [
                    "L4",
                    "L5",
                    "M6",
                    "M3",
                    "M5"
                ],
                [
                    "L2",
                    "L1",
                    "L5",
                    "M6",
                    "L4"
                ],
                [
                    "M2",
                    "M6",
                    "L3",
                    "L4",
                    "L5"
                ],
                [
                    "M3",
                    "L3",
                    "L4",
                    "L2",
                    "L5"
                ]
            ],
            "evaluatedArea": [
                [
                    "M5",
                    "L2",
                    "L3"
                ],
                [
                    "L5",
                    "M6",
                    "M3"
                ],
                [
                    "L1",
                    "L5",
                    "M6"
                ],
                [
                    "M6",
                    "L3",
                    "L4"
                ],
                [
                    "L3",
                    "L4",
                    "L2"
                ]
            ],
            "betWayWins": [],
            "totalBetWayWinnings": 0,
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "currentMultiplier": 1,
            "freespinTriggeredThisSpin": false,
            "randomM1WildModeTriggeredThisSpin": false,
            "randomM2WildModeTriggeredThisSpin": false,
            "stackedWildModeTriggeredThisSpin": false,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinsLeftBefore": 0,
            "addedNumberOfFreespinsThisSpin": 0,
            "freespinMultiplierBefore": 1,
            "freespinMultiplierAfter": 1,
            "symbolsCollectedBefore": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "symbolsCollectedAfter": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "nearWinBigWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "meterFSReset": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "allWinPositions": [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "fsMeterAfterEachReel": [],
            "fsMeterMaxAfterReelIndex": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "stackedModeOverlay": [
                false,
                false,
                false,
                false,
                false
            ],
            "stackedNearWinReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "numberOfWaysWon": 0,
            "alicanStacked": [
                "X",
                "X",
                "X",
                "X",
                "X"
            ]
        };
    }
}